import { defineNuxtPlugin, useNuxtApp } from 'nuxt/app';
import { useQueueStore } from '~~/common/stores/queue';

export default defineNuxtPlugin(function () {
  const nuxtApp = useNuxtApp();
  const queueStore = useQueueStore(nuxtApp.$pinia);

  queueStore.$subscribe((mutation, { queue, errorQueue }) => {
    if (queue.length) {
      queueStore.startWorker();
    }
    if (errorQueue.length) {
      queueStore.startErrorWorker();
    }
  });
});
